import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Calendar, Phone, Menu, Info, HelpCircle, Search, Upload } from 'lucide-react';
import './MobileBottomNav.css';

const MobileBottomNav = ({ onMenuClick, onSearchClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };
  
  const handleNavClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  // Pages with floating pill header (hamburger already in pill)
  const hasFloatingPill = ['/', '/about', '/contact', '/bookings', '/faqs', '/services', 
    '/locations/coffs-harbour', '/locations/telehealth', '/clinics',
    '/privacy-policy', '/terms-and-conditions', '/refer',
    '/autism-assessment', '/adhd-assessment', '/fasd-assessment', '/learning-assessment',
    '/what-to-expect', '/therapy', '/schools', '/referrers', '/fees'].includes(location.pathname);

  return (
    <nav className="mobile-bottom-nav">
      {/* Show symbol logo on floating pill pages - positioned first (far left) */}
      {hasFloatingPill && (
        <button 
          onClick={() => handleNavClick('/')}
          className="mobile-bottom-nav-logo"
          aria-label="Go to home"
        >
          <img 
            src="/images/logos/clinical-minds-symbol.png"
            alt="Clinical Minds Symbol"
            className="bottom-nav-logo-image"
          />
        </button>
      )}
      
      <button 
        onClick={() => handleNavClick('/')}
        className={`mobile-bottom-nav-item ${isActive('/') ? 'active' : ''}`}
      >
        <Home size={20} />
        <span>Home</span>
      </button>
      
      <button 
        onClick={() => handleNavClick('/faqs')}
        className={`mobile-bottom-nav-item ${isActive('/faqs') ? 'active' : ''}`}
      >
        <HelpCircle size={20} />
        <span>FAQ</span>
      </button>
      
      <button 
        onClick={() => handleNavClick('/refer')}
        className={`mobile-bottom-nav-item ${isActive('/refer') ? 'active' : ''}`}
      >
        <Upload size={20} />
        <span>Refer</span>
      </button>
      
      <button 
        onClick={() => handleNavClick('/bookings')}
        className={`mobile-bottom-nav-item ${isActive('/bookings') ? 'active' : ''}`}
      >
        <Calendar size={20} />
        <span>Book</span>
      </button>
      
      {/* Search button - always visible */}
      <button 
        onClick={onSearchClick}
        className="mobile-bottom-nav-item"
      >
        <Search size={20} />
        <span>Search</span>
      </button>
      
      {/* Hide Menu button on pages with floating pill (hamburger already in pill) */}
      {!hasFloatingPill && (
        <button 
          className="mobile-bottom-nav-item"
          onClick={onMenuClick}
        >
          <Menu size={20} />
          <span>Menu</span>
        </button>
      )}
    </nav>
  );
};

export default MobileBottomNav;
